export default __webpack_public_path__ + "static/media/LogoVH.6ea6c2ba.svg";